import React, { useRef } from 'react';
import { hot } from 'react-hot-loader/root';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import 'swiper/swiper-bundle.css';

import * as S from './MobileSwiper.styles';

import Icon from '~/core/scripts/components/Icon';

SwiperCore.use([]);

const MobileSwiper = () => {
  const swiperRef = useRef(null);
  const indicators = useStoreState((state) => state.app.indicators);
  const setIndicator = useStoreActions((actions) => actions.app.setIndicator);
  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  const restartDrawing = useStoreActions(
    (actions) => actions.app.restartDrawing
  );

  return (
    <S.SwiperOuter isDrawingEnabled={isDrawingEnabled}>
      <div style={{ position: 'relative' }}>
        <S.SwiperInner>
          <Swiper
            ref={swiperRef}
            slidesPerGroup={1}
            navigation={false}
            loop
            threshold={10}
            slidesPerView={1}
            spaceBetween={0}
            onSlideChange={({ activeIndex }) => {
              let indexToGoTo = (activeIndex - 1) % indicators.length;
              // when the first slide is active and the user clicks left, it should go to the last one
              if (indexToGoTo === -1) indexToGoTo = indicators.length - 1;
              if (
                !Number.isNaN(indexToGoTo) &&
                indexToGoTo < indicators.length
              ) {
                const indicatorToBeSelected = indicators[indexToGoTo];
                if (indicatorToBeSelected) {
                  setIndicator(indicatorToBeSelected);
                }
              }
            }}
          >
            {indicators.map((indicator, i) => (
              <SwiperSlide key={indicator.key + i}>
                <div>
                  <S.IndicatorTitle
                    dangerouslySetInnerHTML={{ __html: indicator.shortLabel }}
                  />
                  <S.IndicatorLabel
                    dangerouslySetInnerHTML={{ __html: indicator.label }}
                  />
                  <S.IndicatorText
                    dangerouslySetInnerHTML={{
                      __html: indicator.description || '',
                    }}
                  />
                  <S.IndicatorSource
                    dangerouslySetInnerHTML={{
                      __html: indicator.source || '',
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </S.SwiperInner>
        <S.PlainPrevButton
          onClick={() => {
            if (!!swiperRef) {
              swiperRef.current.swiper.slidePrev();
            }
          }}
        >
          <Icon type="tall_caret_left" />
        </S.PlainPrevButton>
        <S.PlainNextButton
          onClick={() => {
            if (!!swiperRef) {
              swiperRef.current.swiper.slideNext();
            }
          }}
        >
          <Icon type="tall_caret_right" />
        </S.PlainNextButton>
      </div>
    </S.SwiperOuter>
  );
};

export default hot(MobileSwiper);
